export const CONTENT_TYPES = [
    { value: "ARTICLE", label: "Article" },
    { value: "FAQ", label: "FAQ" },
    { value: "GUIDE", label: "Guide" },
    { value: "PROCEDURE", label: "Procédure" },
    { value: "NOTE", label: "Note" },
    { value: "SONDAGE", label: "Sondage" },
];

export const DOCUMENT_TYPES = [
    { value: "PDF", label: "PDF" },
    { value: "WORD", label: "Word" },
    { value: "EXCEL", label: "Excel" },
    { value: "PPT", label: "PowerPoint" },
    { value: "IMAGE", label: "Image" },
    { value: "VIDEO", label: "Vidéo" },
    { value: "OTHER", label: "Autre" },
];

export const CONTENT_STATUSES = [
    { value: "DRAFT", label: "Brouillon" },
    { value: "SUBMITTED", label: "Soumis" },
    { value: "APPROVED", label: "Approuvé" },
    { value: "REJECTED", label: "Rejeté" },
    { value: "PUBLISHED", label: "Publié" },
    { value: "ARCHIVED", label: "Archivé" },
    { value: "DELETED", label: "Supprimé" },
    { value: "ACTIVE", label: "Actif" },
    { value: "INACTIVE", label: "Inactif" },
    { value: "LOCKED", label: "Verrouillé" },
];

const mapLabel = (items, value, fallback = "-") =>
    items.find((item) => item.value === value)?.label || value || fallback;

export const contentTypeLabel = (value) => mapLabel(CONTENT_TYPES, value);
export const documentTypeLabel = (value) => mapLabel(DOCUMENT_TYPES, value);
export const statusLabel = (value) => mapLabel(CONTENT_STATUSES, value);

export const normalizeText = (value) =>
    String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

export const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString("fr-FR");
};

export const formatBytes = (bytes) => {
    const value = Number(bytes || 0);
    if (!value) return "-";
    if (value < 1024) return `${value} o`;
    if (value < 1024 * 1024) return `${Math.round(value / 102.4) / 10} Ko`;
    return `${Math.round(value / 1024 / 102.4) / 10} Mo`;
};

export const getRoleText = (role) => {
    if (!role) {
        return "";
    }

    let rawRole = "";

    if (typeof role === "string") {
        rawRole = role;
    } else if (typeof role === "object") {
        rawRole =
            role.name ||
            role.code ||
            role.roleName ||
            role.authority ||
            role.libelle ||
            role.label ||
            "";
    }

    const normalizedRole = String(rawRole).trim().toUpperCase();

    switch (normalizedRole) {
        case "ADMIN":
        case "ROLE_ADMIN":
        case "ADMINISTRATEUR":
            return "Administrateur";

        case "SUPER_ADMIN":
        case "ROLE_SUPER_ADMIN":
            return "Super administrateur";

        case "RESPONSABLE_CONNAISSANCE":
        case "ROLE_RESPONSABLE_CONNAISSANCE":
        case "KNOWLEDGE_MANAGER":
            return "Responsable de connaissance";

        case "COLLABORATEUR":
        case "ROLE_COLLABORATEUR":
        case "USER":
        case "ROLE_USER":
            return "Collaborateur";

        default:
            return rawRole || "";
    }
};

export const isKnowledgeAdminRole = (role) => {
    const text = normalizeText(getRoleText(role));
    return (
        text.includes("administrateur") ||
        text.includes("admin") ||
        text.includes("knowledge_admin") ||
        text.includes("kms_admin")
    );
};

export const getCurrentRole = (state) =>
    state.role?.selectedRole ||
    state.auth?.user?.role ||
    state.auth?.user?.roles?.[0] ||
    state.auth?.user?.authorities?.[0] ||
    state.auth?.user?.selectedRole ||
    state.user?.currentUser?.role ||
    state.user?.currentUser?.roles?.[0] ||
    state.user?.currentUser?.authorities?.[0] ||
    state.user?.currentUser?.selectedRole ||
    state.profile?.currentUser?.role ||
    state.profile?.currentUser?.roles?.[0] ||
    state.profile?.currentUser?.authorities?.[0] ||
    null;

export const getCurrentUser = (state) =>
    state.auth?.user ||
    state.auth?.currentUser ||
    state.user?.currentUser ||
    state.user?.profile ||
    state.profile?.currentUser ||
    null;

export const hasItemRight = (item, right, fallback = false) =>
    item?.[right] === undefined || item?.[right] === null ? fallback : Boolean(item[right]);

export const flattenTree = (nodes = [], level = 0, parentPath = "") =>
    (nodes || []).flatMap((node) => {
        const label = node.name || node.nom || node.code || `Répertoire ${node.id}`;
        const path = node.path || (parentPath ? `${parentPath} / ${label}` : label);
        const row = { ...node, __level: level, __label: label, __path: path };
        const children = node.children || node.subRepertoires || node.subRepositories || [];
        return [row, ...flattenTree(children, level + 1, path)];
    });

export const getUserPermissionForRepertoire = (repertoire, user) => {
    const userId = user?.id || sessionStorage.getItem("uid") || localStorage.getItem("uid");
    const permissions = repertoire?.userPermissions || [];
    const permission = permissions.find((item) => String(item.userId || item.id) === String(userId));
    return {
        canConsult: Boolean(permission?.canConsult || permission?.canCreate || permission?.canValidate || repertoire?.canView),
        canCreate: Boolean(permission?.canCreate || repertoire?.canCreate),
        canValidate: Boolean(permission?.canValidate || repertoire?.canValidate),
    };
};

export const getContentTitle = (item) => item.title || item.name || "-";
export const getDocumentTitle = (item) => item.title || item.originalFilename || item.storedFilename || "-";

export const getPreviewUrl = (item) => item.previewUrl || item.downloadUrl || "";
export const getDownloadUrl = (item) => item.downloadUrl || item.previewUrl || "";


